export const PORTAL_UNAVAILABLE_PATH = '/client-portal-unavailable';

export const redirectToPortalUnavailable = (): void => {
  window.location.replace(`${process.env.REACT_APP_MAIN_PAGE_URL}${PORTAL_UNAVAILABLE_PATH}`);
};
